import { render, staticRenderFns } from "./VisualizarReceitaCampanha.vue?vue&type=template&id=0776527e&"
import script from "./VisualizarReceitaCampanha.vue?vue&type=script&lang=js&"
export * from "./VisualizarReceitaCampanha.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarReceitaCampanha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports